// import { closeTicket } from "api/tickets";

const closeTicketService = async (id: any) => {
  // const response: any = await closeTicket(id);
  // if (response.status === 200) {
  //   return { message: "success" };
  // }
  // if (response.status !== 200) {
  //   return { message: "failure" };
  // }
};

export default closeTicketService;